import React, { Component, Suspense, lazy } from 'react';
import { Route, Switch, BrowserRouter, Redirect } from 'react-router-dom';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import Login from './components/login';
import Home from './components/home';
import Test from './components/test';
import { getCookie } from './util_functions';

import Notifications from './components/views/notifications';
import Blog from './components/blog';
import BlogPost from './components/blog/post';
import GlobalChatNotificationCoordinator from './components/chat/chat/global_notification_coordinator';
import './common.css';

import 'react-tooltip/dist/react-tooltip.css';
// Lazy load chat components to reduce initial bundle size
const StudentChat = lazy(() => import('./components/chat/home/student'));
const TeacherChat = lazy(() => import('./components/chat/home/teacher'));

export default class App extends Component {
  render() {
    const cmsToken = getCookie('cms_token_3');

    return (
      <>
        <ReactTooltip id="my-tooltip" style={{ overflow: 'visible', zIndex: '100' }} />
        <Notifications />
        <GlobalChatNotificationCoordinator />
        <BrowserRouter>
          <Switch>
            <Route
              exact
              path="/"
              render={(props) => (cmsToken ? <Home {...props} /> : <Login />)}
            />
            <Route exact path="/test" component={Test} />

            <Route
              exact
              path="/student_chat"
              render={(props) => (
                <Suspense
                  fallback={
                    <div style={{ textAlign: 'center', padding: '50px', fontSize: '20px' }}>
                      Loading Chat...
                    </div>
                  }
                >
                  <StudentChat {...props} />
                </Suspense>
              )}
            />
            <Route
              exact
              path="/teacher_chat"
              render={(props) => (
                <Suspense
                  fallback={
                    <div style={{ textAlign: 'center', padding: '50px', fontSize: '20px' }}>
                      Loading Chat...
                    </div>
                  }
                >
                  <TeacherChat {...props} />
                </Suspense>
              )}
            />

            <Route exact path="/blog" component={Blog} />
            <Route exact path="/blog/:slug" component={BlogPost} />

            <Redirect from="/login" to="/" />
            <Redirect from="/home" to="/" />
            <Route exact path="*" component={Home} />
          </Switch>
        </BrowserRouter>
      </>
    );
  }
}
